 export const skillsData = [
    'HTML',
    'Javascript',
    'CSS',
    'React',
    'Django',
    'Bootstrap',
    'Angular',
    'Python',
    'Typescript',
    'MySQL',
    'PostgreSQL',
    'Graphql',
]


